import { UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { FieldValues } from 'react-hook-form';
import type { AnyObjectSchema } from 'yup';

import { ArrayField, Field } from '@/components/PersonInPlaceEditor/types';

export enum RecordType {
  InsurancePolicy = 'insurance_policy',
  RemitClaim = 'remit_claim',
  RemitFinancialInfo = 'remint_financial_info',
  RemitServiceLine = 'remit_service_line',
  RemitAdjustment = 'remit_adjustment',
  RemitRemark = 'remit_remark',
  Remit = 'remit'
}

export interface Props<T extends FieldValues, R> {
  deleteMutation?: UseMutationResult<
    void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AxiosError<unknown, any>,
    string,
    unknown
  >;
  /**
   * If true, double clicking on a field will allow you to edit it
   **/
  doubleClickToEdit?: boolean;
  disableEdit?: boolean;
  disableNew?: boolean;
  editButtonClass?: string;
  fields: Field<T>[] | ArrayField<T>;
  /**
   * The mutation to call when the form is submitted
   */
  mutation: UseMutationResult<
    R,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AxiosError<unknown, any>,
    { id?: string; values: Partial<T> },
    unknown
  >;
  newRecord?: boolean;
  /**
   * The text to display on the new record button
   */
  newRecordButtonText?: string;
  /**
   * The record to edit. Ex: Person
   */
  record: T;
  recordType?: RecordType;
  schema?: AnyObjectSchema;
  sectionEditor?: boolean;
  /**
   * If true, all fields will be sent to the server, even if they haven't changed
   * This is useful if you are passing in default values for a new record.
   */
  sendAllFields?: boolean;
  submittedValuesManipulator?: (values: Pick<Partial<T>, string>) => Promise<T>;
  subsectionEditor?: boolean;
  /**
   * A function that will be called to check if the form is valid, and return a message if it is not.
   */
  checkValidationMessage?: (values: Partial<T>) => React.ReactNode | null;
}
